import * as Ably from 'ably';

export { Ably };

const DEFAULT_API_KEY = import.meta.env.VITE_ABLY_API_KEY || '';

let instance: Ably.Realtime | null = null;

export function getAblyClient(): Ably.Realtime {
  if (!instance) {
    instance = new Ably.Realtime({
      key: DEFAULT_API_KEY,
      transports: ['web_socket'],
      disconnectedRetryTimeout: 15000,
      suspendedRetryTimeout: 30000,
      realtimeRequestTimeout: 10000,
    });
  }
  return instance;
}

export function getAblyChannel(channelName: string): Ably.RealtimeChannel {
  return getAblyClient().channels.get(channelName);
}
